import { useContext, useState } from "react";
import { withApollo } from "react-apollo";
import { useSelector } from "react-redux";
import { PaginationContext } from "../../../components/shared/pagination/PaginationContext";
import { CustomFilterContext } from "../custom-filter/context";
import { exportItemToCSV } from "./export-item-to-csv";
import LOGBOOK_LABEL from "./../../../utils/constants/logbookLabel";
import { useParams } from "react-router-dom";
import { OwcListItem } from "@one/react";
import { CircularProgress } from "@mui/material";
import { CoverSheetMainPageContext } from "../../cover-sheet/cover-sheet-main-page-context/context";
import { SearchTextContext } from "../log-book-item-fillter/suggester/search-context/context";
import { formTypes } from "../../../constants";

const ExportItemToCSVButton = ({ client, fetchingFn, dataTestId, fileNamePrefix, mapFn, id }) => {
  const paginationContext = useContext(PaginationContext);
  const customFilterContext = useContext(CustomFilterContext);
  const searchTextContext = useContext(SearchTextContext);
  const { logType, allLogType } = useContext(CoverSheetMainPageContext);
  const storeUser = useSelector((store) => store.user);
  const [exporting, setExporting] = useState(false);
  const { inventoryId } = useParams();

  const exportXlsx = async () => {
    setExporting(true);
    await exportItemToCSV({
      client,
      customFilterContext,
      paginationContext,
      searchTextContext,
      storeUser,
      fetchingFn,
      fileNamePrefix,
      mapFn,
      inventoryId,
      logType: logType === formTypes.ALL_LOG ? allLogType : logType
    });
    setExporting(false);
  };

  return (
    <OwcListItem
      data-testid={`export-csv-${dataTestId}-button`}
      onClick={exportXlsx}
      disabled={
        logType === formTypes.ALL_LOG
          ? paginationContext.runData.length === 0 && paginationContext.actionData.length === 0
          : paginationContext.data.length === 0 || paginationContext.fetching || exporting
      }
      id={id}
    >
      {exporting && <CircularProgress size={20} style={{ marginRight: 6 }} />}
      {LOGBOOK_LABEL.BUTTON.export_CSV}
    </OwcListItem>
  );
};

export default withApollo(ExportItemToCSVButton);
